import { useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'
import { routes } from 'src/navigation/routes'

const ClassroomRow = ({ item, onInviteClick, onDeleteClick, onEditClick }) => {
  const history = useHistory()
  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const goToClassroom = (e) => {
    e.preventDefault()
    history.push(routes.classrooms.students(item.id))
  }

  const classroomName = (item.grade?.name ?? '').replace('Kindergarten', 'K')

  return (
    <div className={`details-item details-item__${item.color}`}>
      <div className="details-item__num cursor-pointer" onClick={goToClassroom}>
        {classroomName}
      </div>
      <div className="details-item__top cursor-pointer" onClick={goToClassroom}>
        <span className="details-item__name">{item.name}</span>
        <ul className="details-item__list">
          <li>
            {/* <i className="hb-ico student-ico"></i> */}
            <span>Student:</span>
            <b>{item.students_count || 0}</b>
          </li>
          <li>
            {/* <i className="hb-ico problems-ico"></i> */}
            <span>Practices:</span>
            <b>{item?.practices_count}</b>
          </li>
          <li>
            {/* <i className="hb-ico test-ico"></i> */}
            <span>Tests:</span>
            <b>{item?.tests_count}</b>
          </li>
        </ul>
      </div>
      <div className="details-item__btns">
        <a href="#" className="second-btn" onClick={goToClassroom}>
          {item.subject?.name ?? ''}
        </a>
      </div>
      <div className={`dropHb ${isMenuOpen ? 'active' : ''}`}>
        <div className="dropHb-top" onClick={handleMenuOpen}>
          <i className="hb-ico dots-ico" />
        </div>
        <div ref={refMenu} className="dropHb-info">
          <ul>
            <li>
              <a onClick={onEditClick} href="#">
                <i className="hb-ico edit-ico" />
                Edit
              </a>
            </li>
            <li>
              <a onClick={onDeleteClick} href="#">
                <i className="hb-ico trash-ico" />
                Delete
              </a>
            </li>
            <li>
              <a onClick={onInviteClick} href="#">
                <i className="hb-ico assign-ico" />
                Invitation
              </a>
            </li>
            {/* <li><a href="#">
              <i className="hb-ico send-ico"></i>
              Send to mark
            </a></li> */}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ClassroomRow
